import React, { useState, useEffect } from 'react';
import { mediaTypes } from 'components/posts';
import NewsCard from '../../cards/js/news-card';
import RelatedNews from '../../related-news/js/related-news';
import { useScreenDetector } from '../../../general/js/hooks/useScreenDetector';

const LiveCardLatestNewsArticles = ({ contentItems, loadMoreArticlesUrl, viewMoreArticlesText }) => {
    const [displayedArticles, setDisplayedArticles] = useState([]);

    const { isMobile } = useScreenDetector();
    useEffect(() => {
        const initialArticles = contentItems.slice(0, 7);
        setDisplayedArticles(initialArticles);
    }, [contentItems]);

    const handleLoadMoreClick = () => {
        window.location.href = loadMoreArticlesUrl || '/latest';
    };

    const mapArticleToModel = (article) => ({
        id: article.id,
        url: article.url,
        bgImage: article.bgImage,
        label: article.label,
        title: article.title,
        subtitle: article.subtitle || '',
        ctaText: 'Read Article',
        type: mediaTypes.ARTICLE,
        schemaOrg: article.schemaOrg || {},
    });

    if (displayedArticles.length === 2) {
        return (
            <div className="live-card-latest-news-videos">
                <div className="live-card-latest-news-videos__group">
                    {displayedArticles.map((article) => (
                        <div className="live-card-latest-news-videos__wrapper" key={article.id}>
                            <div className="live-card-latest-news-videos__item">
                                <NewsCard model={mapArticleToModel(article)} bemModifiers={['one-third']}/>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="live-card-latest-news-videos__loadmore">
                    <button className="button button--primary" type="button" onClick={handleLoadMoreClick}>
                        {viewMoreArticlesText || 'View More articles'}
                    </button>
                </div>
            </div>
        );
    }

    if (displayedArticles.length > 0) {
        return (
            <div className="live-card-latest-news-videos">
                {!isMobile ? (
                    <div className="live-card-latest-news-videos__group">
                        <div className="live-card-latest-news-videos__wrapper">
                            <div className="live-card-latest-news-videos__item">
                                <NewsCard model={mapArticleToModel(displayedArticles[0])} bemModifiers={['one-third']}/>
                            </div>
                        </div>
                        <div className="live-card-latest-news-videos__wrapper">
                            <div className="live-card-latest-news-videos__item">
                                <RelatedNews
                                    model={displayedArticles.slice(1).map(mapArticleToModel)}
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="live-card-latest-news-videos__group">
                        <div className="live-card-latest-news-videos__wrapper">
                            <div className="live-card-latest-news-videos__item">
                                <RelatedNews
                                    model={displayedArticles.map(mapArticleToModel)}
                                />
                            </div>
                        </div>
                    </div>
                )}
                <div className="live-card-latest-news-videos__loadmore">
                    <button className="button button--primary" type="button" onClick={handleLoadMoreClick}>
                        {viewMoreArticlesText || 'View More articles'}
                    </button>
                </div>
            </div>
        );
    }

    return (<></>);
};

export default LiveCardLatestNewsArticles;
